export function createPayoutClient(transport) {
    return {
        /**
         * List this tenant's payout batches, as a projection of the payouts in each
         *
         * Requires scope: payout:batch:read
         */
        listPayoutBatches(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/payouts",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /v1/payouts
         *
         * Requires scope: payout:create
         */
        createPayout(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/payouts",
                body,
                options,
            });
        },
        /**
         * List the payouts this merchant is the beneficiary of
         *
         * Requires scope: payout:beneficiary:read
         */
        listMerchantPayouts(merchantId, limit, afterRequestedAt, afterPayoutId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}/payouts`,
                query: { limit: limit, afterRequestedAt: afterRequestedAt, afterPayoutId: afterPayoutId },
                options,
            });
        },
        /**
         * GET /v1/payouts/{payoutId}
         *
         * Requires scope: payout:read
         */
        getPayout(payoutId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/payouts/${encodeURIComponent(payoutId)}`,
                options,
            });
        },
        /**
         * Approve every payout in one run
         *
         * Requires scope: payout:approve
         */
        approvePayoutBatch(batchId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/payout-batches/${encodeURIComponent(batchId)}/approval`,
                body,
                options,
            });
        },
        /**
         * POST /v1/payouts/{payoutId}/approval
         *
         * Requires scope: payout:approve
         */
        approvePayout(payoutId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/payouts/${encodeURIComponent(payoutId)}/approval`,
                body,
                options,
            });
        },
        /**
         * POST /v1/payouts/{payoutId}/submission
         *
         * Requires scope: payout:submit
         */
        submitPayout(payoutId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/payouts/${encodeURIComponent(payoutId)}/submission`,
                body,
                options,
            });
        },
        /**
         * POST /v1/payouts/{payoutId}/reconciliation
         *
         * Requires scope: payout:reconcile
         */
        reconcilePayout(payoutId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/payouts/${encodeURIComponent(payoutId)}/reconciliation`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=payout.js.map